import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  order(event) {
    const { orderType, orderElem } = event.params
    if (!orderElem || !this.hasFormTarget) return

    const input = document.querySelector(orderElem)
    if (!input) return

    input.value = orderType
    this.formTarget.submit()
  }
}
